import {get} from '@/lib/fetcher';

export default {
    namespaced: true,
    state: () => ({
        tournamentName: '',
        contestType: -1,
        pairId: -1,
        teamId: -1,
        individualPlayerId: -1,
        id: '',
        directors: [],
        series: {},
        simultaneousType: 0,
        isRunning: true,
        sectors: {
            Phases: {}
        }
    }),
    mutations: {
        changeTournamentName(state, newTournamentName) {
            state.tournamentName = newTournamentName;
        },
        changeIsRunning(state, newIsRunning) {
            state.isRunning = newIsRunning;
        },
        changeId(state, newId) {
            state.id = newId;
        },
        changeDirectors(state, newDirectors) {
            state.directors = newDirectors;
        },
        changeContestType(state, newContestType) {
            state.contestType = newContestType;
        },
        changeSectors(state, newSectors) {
            state.sectors = newSectors;
        },
        changeSeries(state, newSeries) {
            state.series = newSeries;
        },
        changePairId(state, newPairId) {
            state.pairId = newPairId;
        },
        changeTeamId(state, newTeamId) {
            state.teamId = newTeamId;
        },
        changeIndividualPlayerId(state, newIndividualPlayerId) {
            state.individualPlayerId = newIndividualPlayerId;
        },
        changeSimultaneousType(state, newSimultaneousType) {
            state.simultaneousType = newSimultaneousType;
        }
    },
    actions: {
        loadTournamentInfo({commit}) {
            get('/api/tournament/info')
                .then(resp => {
                    commit('changeTournamentName', resp.TournamentName);
                    commit('changeId', resp.Id);
                    commit('changeDirectors', resp.Directors);
                    commit('changeContestType', resp.TournamentType);
                    commit('changePairId', resp.PairId);
                    commit('changeTeamId', resp.TeamId);
                    commit('changeIndividualPlayerId', resp.IndividualPlayerId);
                    commit('changeSimultaneousType', resp.SimultaneousType);
                    commit('changeIsRunning', resp.IsRunning !== false);
                });

        },
        loadSectors({commit}) {
            get('/api/tournament/sectors')
                .then(resp => {
                    commit('changeSectors', resp);
                });
        }
    },
    getters: {
        currentRound: (state, getters, rootState, rootGetters) => {
            return Math.min(
                ...rootGetters['players/teamCurrentSessionMap']
                    .filter(el => !el.Completed)
                    .map(el => el.round)
            );
        },
        currentSession: (state, getters, rootState, rootGetters) => {
            return rootGetters['players/teamCurrentSessionMap']
                    .filter(el => !el.Completed)
                    .map(el => el.session)[0] ?? 0;
        },
        currentTableState: (state, getters, rootState, rootGetters) => {
            const rootGetter = rootGetters['players/playerCurrentSessionMap'];
            if (rootGetter == null || rootGetter.length === 0) {
                return null;
            }
            const temp = rootGetter
                .find(el => el.round === getters.currentRound);
            return temp ? {...temp} : null;
        },
        sector: state => state.sectors,
        series: state => state.series,
        tournamentName: state => state.tournamentName,
        isRunning: state => state.isRunning,
        directors: state => state.directors,
        pairId: state => state.pairId,
        teamId: state => state.teamId,
        individualPlayerId: state => state.individualPlayerId,
        contestType: state => state.contestType,
        simultaneousType: state => state.simultaneousType,
        contestCurrentStateMap: (state, getters, rootState, rootGetters) => {
            const sectors = rootGetters['tournament/sector'];

            const maxPhase = Math.max(...Object.keys(sectors.Phases ?? {}).map(n => parseInt(n)));
            if (maxPhase < 1) {
                return [];
            }

            const currentSeries = Object.values(sectors.Phases[sectors.CurrentPhase].Series);

            const currentGroups = currentSeries.map(serie => {
                const maxSession = Math.max(...Object.keys(serie.Sessions ?? {}).map(n => parseInt(n)));

                //Last session on each serie
                return serie.Sessions[maxSession] ?? {Groups: []};
            }).flatMap(session => {
                return Object.values(session.Groups)
            })

            return currentGroups
        }
    }
};
